import { render, staticRenderFns } from "./m-link.vue?vue&type=template&id=32175cb0&scoped=true&"
var script = {}
import style0 from "./m-link.vue?vue&type=style&index=0&id=32175cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32175cb0",
  null
  
)

export default component.exports